import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addShiftAssignment,
  addTeamAssignment,
  addTimeOff,
  deleteTimeOff,
  fetchStaffDutyCalendar,
  removeShiftAssignment,
  updateTimeOff,
} from "../../apis/staffDutyCalendar";

import type { ShiftType, TimeOffType } from "../../utils/types/staffDutyCalendar";

export const fetchStaffDutyCalendarData = createAsyncThunk(
  "staffDutyCalendar/fetch",
  async (agentIds: string[], { rejectWithValue }) => {
    try {
      return await fetchStaffDutyCalendar(agentIds);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.staffDutyCalendar.isDataFetched;
    },
  }
);

export const addShiftAssignmentData = createAsyncThunk(
  "staffDutyCalendar/addShiftAssignment",
  async (
    data: { date: string; shift: ShiftType; personId: string },
    { rejectWithValue }
  ) => {
    try {
      return await addShiftAssignment(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTeamAssignmentData = createAsyncThunk(
  "staffDutyCalendar/addTeamAssignment",
  async (
    data: { date: string; shift: ShiftType; teamId: string },
    { rejectWithValue }
  ) => {
    try {
      return await addTeamAssignment(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeShiftAssignmentData = createAsyncThunk(
  "staffDutyCalendar/removeShiftAssignment",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await removeShiftAssignment(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTimeOffData = createAsyncThunk(
  "staffDutyCalendar/addTimeOff",
  async (
    data: {
      personId: string;
      type: TimeOffType;
      startDate: string;
      endDate: string;
      notes?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      return await addTimeOff(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTimeOffData = createAsyncThunk(
  "staffDutyCalendar/updateTimeOff",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        personId?: string;
        type?: TimeOffType;
        startDate?: string;
        endDate?: string;
        notes?: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      return await updateTimeOff(id, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTimeOffData = createAsyncThunk(
  "staffDutyCalendar/deleteTimeOff",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await deleteTimeOff(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
